import React from "react";
import "./CVSauvegardes.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CVSearchBar from "../CVSearchBar/CVSearchBar";
import { Toast } from "primereact/toast";
import { updatePagination } from "Redux/Actions/paginationActions";
import Pagination from "Components/Pagination/Pagination";
import { useRef, useEffect } from "react";
import { useState } from "react";
import CV from "../CV/CV";
import { useFetchGetPagination } from "Services/api";

const CVSauvegardes = (props) => {
  const saveRef = useRef(null);
  const uploadToast = useRef(null);
  const cancelToast = useRef(null);

  //? State that will handled the list of saved resumes
  const [savedResumeUrl, setSavedResumeUrl] = useState(null);
  const savedResumeUsers = useFetchGetPagination(
    savedResumeUrl,
    props.auth.token
  );
  //? --------------------------------------------------

  useEffect(() => {
    //? Remise à zéro des informations de paginations pour ne pas interférer les affichages des autres pages
    return () => {
      props.handleUpdatePagination({ currentPage: 1 });
      props.handleUpdatePagination({ paginationBasicFirst: 0 });
      props.handleUpdatePagination({ paginationBasicRows: 12 });
    };
  }, []);

  /**
   * @see fetchSavedResumes()
   */
  useEffect(async () => {
    await fetchSavedResumes();
  }, []);

  /**
   *? Fetch the saved resumes of the user connected
   */
  const fetchSavedResumes = async () => {
    //? Create the URL of the API endpoint to be called
    const url = new URL(`${process.env.REACT_APP_BASE_URL_API}/cvs`);

    //? Add the filter parameter to the URL
    url.searchParams.set("savedByUsers", props.auth.userConnected.id);

    //? Update the state with the new url
    setSavedResumeUrl(url);
  };

  return (
    <div>
      <Toast ref={uploadToast} />
      <Toast ref={cancelToast} />
      <div className="CVs__container">
        <div className="CVs__container__title">
          <h1 className="h1_trait_dessus">
            {props.items[props.activeIndex].label}
          </h1>
        </div>
        <div className="offre_search_bar__filtres">
          <CVSearchBar />
        </div>
        <div className="CVs__container__cvs">
          {savedResumeUsers?.data?.length > 0 ? (
            savedResumeUsers?.data
              //? Filter the CVs that have no user
              .filter((cv) => cv.user !== null)
              //? Slice the array to display only the CVs of the current page (pagination)
              .slice(
                props.pagination.paginationBasicFirst,
                props.pagination.paginationBasicRows *
                  props.pagination.currentPage
              )
              .map((cv) => (
                <CV
                  key={cv.id}
                  firstname={cv.user.firstname}
                  surname={cv.user.surname}
                  titre={cv.user.profilTitle}
                  userId={cv.user.id}
                  educations={cv.educations}
                  roles={cv.user.userRoles}
                  resumeId={cv.id}
                  uploadToast={uploadToast}
                  cancelToast={cancelToast}
                  imageUrl={cv.user.imageUrl ? cv.user.imageUrl : null}
                />
              ))
          ) : (
            <span>Aucun CV n&apos;est sauvegardé</span>
          )}
        </div>
        <Pagination data={savedResumeUsers.data} refItemParent={saveRef} />
      </div>
    </div>
  );
};

CVSauvegardes.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  cvs: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  pagination: state.pagination,
  cvs: state.cvs,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CVSauvegardes);
